import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store/index.js'
import router from '../routes'

// 根据运行模式，增加前缀
let baseUrl = 'http://127.0.0.1:8132'
const service = axios.create({
  baseURL: baseUrl,
  // timeout: 5000
  timeout: 60000
})
// 请求拦截
service.interceptors.request.use(
  config => {
    config.url = store.state.moduleUrl + config.url
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截
service.interceptors.response.use(
  response => {
    const res = response
    if (res.status !== 200 && res.status !== "200") {
      Message({
        message: res.message || res.msg || '与服务器的连接可能中断，请尝试重新连接',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || '与服务器的连接可能中断，请尝试重新连接'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // ebug
    if (store.state.login) {
      Message({
        message: '与服务器的连接可能中断，请尝试重新连接',
        type: 'error',
        showClose: true,
        duration: 5 * 1000
      });
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/common/lockhostRequest.js